<template>
    <div class="clearfix">
        <line-chart :id="id" :option="chartOptions"></line-chart>

        <div class="table-box" style="border: 0">
            <div class="title">
                <h3>班级学习情况</h3>
            </div>
            <div class="search-box">
                <Select v-model="model1"
                        style="width:240px;margin-right: 10px"
                >
                    <Option :value="item.value"  v-for="item in collegeArr" :key="item.value">{{item.title}}</Option>
                </Select>
                <Select v-model="model3"
                        style="width:240px;margin-right: 10px"
                >
                    <Option :value="item.value"  v-for="item in gradeArr" :key="item.value">{{item.title}}</Option>
                </Select>
                <Select v-model="model2"
                        style="width:140px;margin-right: 10px"
                >
                    <Option :value="item.value"  v-for="item in classArr" :key="item.value">{{item.title}}</Option>
                </Select>
                <Select v-model="model4"
                        style="width:140px;margin-right: 10px"
                >
                    <Option :value="item.value"  v-for="item in stuArr" :key="item.value">{{item.title}}</Option>
                </Select>
            </div>
            <Table ref="selection" :columns="columns" :data="datas" ></Table>
        </div>
    </div>
</template>

<script>
    import lineChart from '../../../../ability/chart/chart'
    export default {
        name: "learnDuration",
        components: {
            lineChart
        },
        data(){
            return{
                id:'test',
                chartOptions:{
                    chart: {
                        type: 'column'
                    },
                    title: {
                        text: '学习时长统计（分钟）',
                        x: 0
                    },
                    pane: {
                        size: '80%'
                    },
                    xAxis: {
                        categories: ['测试团团'],
                        tickmarkPlacement: 'on',
                        lineWidth: 0
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: '学习时长统计（分钟）'
                        }
                    },
                    tooltip: {
                        shared: true,
                        pointFormat: '<span style="color:{series.color}">{series.name}: <b>{point.y:,.0f}</b><br/>'
                    },
                    legend: {
                        align: 'right',
                        verticalAlign: 'top',
                        y: 70,
                        layout: 'vertical'
                    },
                    series: [{
                        name: '人工智能学生1',
                        data: [4],
                    }]
                },
                model1:'0',
                model2:'0',
                model3:'0',
                model4:'0',
                collegeArr:[
                    {
                        value:'0',
                        title:'全部学院'
                    },
                    {
                        value:'1',
                        title:'人工智能学院'
                    }
                ],
                classArr:[
                    {
                        value:'0',
                        title:'全部班级'
                    },
                    {
                        value:'1',
                        title:'人工智能体验一班'
                    }
                ],
                gradeArr:[
                    {
                        value:'0',
                        title:'全部年级'
                    },
                    {
                        value:'1',
                        title:'2019'
                    }
                ],
                stuArr:[
                    {
                        value:'0',
                        title:'全部学生'
                    },
                    {
                        value:'1',
                        title:'测试团团'
                    },
                ],
                datas: [
                    {
                        className:'人工智能体验一班',
                        stuName:'测试团团',
                        studentID:'123456',
                        courseName:'人工智能课程实训-AI 博',
                        contentName:'AI博弈平台开发任务1',
                        startStuTime:'2019-09-10 13:41:50',
                        endStuTime:'2019-09-10 13:42:11',
                        stuDur:'2'
                    }
                ],
                columns: [
                    {
                        title: '班级名称',
                        key: 'className',
                        sortable: true
                    },
                    {
                        title: '学生名称',
                        key: 'stuName'
                    },
                    {
                        title: '学号',
                        key: 'studentID'
                    },
                    {
                        title: '课程名称',
                        key: 'courseName'
                    },
                    {
                        title: '资源名称',
                        key: 'contentName'
                    },
                    {
                        title: '开学学习时间',
                        key: 'startStuTime',
                        sortable: true
                    },
                    {
                        title: '结束学习时间',
                        key: 'endStuTime',
                        sortable: true
                    },
                    {
                        title: '学习时长（分钟）',
                        key: 'stuDur'
                    },
                ],
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../../../style/index";
</style>